import { render, staticRenderFns } from "./PhonebookView.vue?vue&type=template&id=9d1ceb62&scoped=true"
import script from "./PhonebookView.vue?vue&type=script&lang=js"
export * from "./PhonebookView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1ceb62",
  null
  
)

export default component.exports